import { BuildingAccessType } from "../api/graphql";

export default function isReadOnly(access: BuildingAccessType | null): boolean {
  return access === BuildingAccessType.READ;
}
